import { render, staticRenderFns } from "./si_skip.vue?vue&type=template&id=0867041b&scoped=true&"
import script from "./si_skip.vue?vue&type=script&lang=js&"
export * from "./si_skip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0867041b",
  null
  
)

export default component.exports